import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAssetsState } from '../../interfaces/state.interfaces';
import { IUploadedAsset } from '../../interfaces/assets.interface';

const initialState: IAssetsState = {
    assets: [],
    page: 1,
    hasNext: true,
};

const assetsSlice = createSlice({
    name: 'assets',
    initialState,
    reducers: {
        SetAssets(state, action: PayloadAction<{ assets: IUploadedAsset[]; hasNext: boolean }>) {
            state.assets = action.payload.assets;
            state.hasNext = action.payload.hasNext;
        },
        AddUploadedAsset(state, action: PayloadAction<IUploadedAsset>) {
            state.assets.unshift(action.payload);
        },
        DeleteAsset(state, action: PayloadAction<number>) {
            state.assets = state.assets.filter((asset) => asset.id !== action.payload);
        },
        LoadMoreAssets(
            state,
            action: PayloadAction<{ assets: IUploadedAsset[]; hasNext: boolean }>,
        ) {
            state.assets = [...state.assets, ...action.payload.assets];
            state.hasNext = action.payload.hasNext;
        },
        SetAssetsPage(state, action: PayloadAction<number>) {
            state.page = action.payload;
        },
        SetAssetsInitialState(state) {
            state.assets = [];
            state.page = 1;
            state.hasNext = true;
        },
    },
});

export const {
    SetAssets,
    AddUploadedAsset,
    DeleteAsset,
    LoadMoreAssets,
    SetAssetsPage,
    SetAssetsInitialState,
} = assetsSlice.actions;

export const assetsReducer = assetsSlice.reducer;
